// extracted by mini-css-extract-plugin
export var locationCard = "_fy-0";